import React from "react";

import './SubscriptionDescription.css';

const SubscriptionDescription = ({ props }) => {
    let contentToRender ;
    switch( window.location.pathname ){
        case '/price':
            contentToRender = (
                <p>
                     Find the protection and security you need to keep your 
                     identity and personal information safe from theft. <b>Save
                     money, time, and peace of mind knowing we have your back.
                     </b>
                </p>
            )
            break;
        case '/':
            contentToRender = (
                <p>
                      Unlock incredible tools, talk to experts in the field, get help 
                      throughout the process, get support for victims, and much
                      more, all in the blink of an eye. <b> All of these amazing things are
                      available to you at an affordable price.
                      </b>
                </p>
            );
            break;

        default:
            contentToRender = null;
            break;
    }

    return (
        <div className="SubscriptionDescription__main-container" >
        
              <div className="SubscriptionDescription__img-container mb-4" >
                    <div className="SubscriptionDescription__inner-img-container">
                        <img src={props.img} alt={props.imgDescription} className="SubscriptionDescription__img" />
                    </div>
            </div> 
            <div className="SubscriptionDescription__title-container mt-4">
                <p>
                    {props.title}
                </p>
            </div>
            <div className="SubscriptionDescription__description-container mt-4">
               
                {contentToRender}
                
            </div>
        </div>
    );
};

export default SubscriptionDescription;